import EmailIcon from '@mui/icons-material/Email';
import { Avatar, Box, Typography } from "@mui/material";
import "../CSS/Layout.css";
import "../CSS/People.css";
import { CurrentStudents, formerStudents } from '../Configurations/PeopleList';

export default function PeoplePage() {
  function peopleCards(peopleConfig) {
    const cards = [];
    for (let i = 0; i < peopleConfig.length; i++) {
      let config = peopleConfig[i];
      cards.push(<Box className="people-card" key={i}>
        <Avatar alt={config.name} src={config.avatar} sx={{ width: "10rem", height: "10rem", mb: "2rem" }} />
        <Typography color="primary" fontSize="1.2rem" fontWeight={800}>{config.name} </Typography>
        <Typography color="secondary" fontSize="1.05rem" fontWeight={600}>{config.title}</Typography>
        {config.email && <Box className="flex-row-left">
          <EmailIcon color="primary" />
          <Typography color="secondary" ml="0.5rem">{config.email}</Typography>
        </Box>
        }
        <Typography fontWeight={300} fontSize="1rem" mt="1rem" textAlign="center">{config.description}</Typography>
      </Box>);
    }
    return cards;
  }
  return (<Box>
    <Typography variant='h2' >Current Students</Typography>
    <Box className="people-list">
      {peopleCards(CurrentStudents)}
    </Box>
    <Typography variant='h2'>Former Students</Typography>
    <Box className="people-list">
      {peopleCards(formerStudents)}
    </Box>
  </Box>);
}